export * from './investments.module';
export * from './components/investments.component';
